import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { VariantPackCostChangeDataFieldsFragmentDoc } from './variant-pack-cost-change-data-fragments.generated';
const defaultOptions = {} as const;

export const SubmitPricingPriceDraftUpdatesForBusinessOrganizationDocument = gql`
  mutation SubmitPricingPriceDraftUpdatesForBusinessOrganization {
    submitPricingPriceDraftUpdateBatchesForBusinessOrganization {
      cost_changes {
        ...VariantPackCostChangeDataFields
      }
      per_supplier {
        alert {
          alert_level
          alert_message
        }
        supplier_id
      }
    }
  }
  ${VariantPackCostChangeDataFieldsFragmentDoc}
`;
export type SubmitPricingPriceDraftUpdatesForBusinessOrganizationMutationFn =
  Apollo.MutationFunction<
    Types.SubmitPricingPriceDraftUpdatesForBusinessOrganizationMutation,
    Types.SubmitPricingPriceDraftUpdatesForBusinessOrganizationMutationVariables
  >;
export function useSubmitPricingPriceDraftUpdatesForBusinessOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SubmitPricingPriceDraftUpdatesForBusinessOrganizationMutation,
    Types.SubmitPricingPriceDraftUpdatesForBusinessOrganizationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SubmitPricingPriceDraftUpdatesForBusinessOrganizationMutation,
    Types.SubmitPricingPriceDraftUpdatesForBusinessOrganizationMutationVariables
  >(SubmitPricingPriceDraftUpdatesForBusinessOrganizationDocument, options);
}
export type SubmitPricingPriceDraftUpdatesForBusinessOrganizationMutationHookResult =
  ReturnType<
    typeof useSubmitPricingPriceDraftUpdatesForBusinessOrganizationMutation
  >;
export type SubmitPricingPriceDraftUpdatesForBusinessOrganizationMutationResult =
  Apollo.MutationResult<Types.SubmitPricingPriceDraftUpdatesForBusinessOrganizationMutation>;
export type SubmitPricingPriceDraftUpdatesForBusinessOrganizationMutationOptions =
  Apollo.BaseMutationOptions<
    Types.SubmitPricingPriceDraftUpdatesForBusinessOrganizationMutation,
    Types.SubmitPricingPriceDraftUpdatesForBusinessOrganizationMutationVariables
  >;
